// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4887cfe","667":"15381e5d","977":"e8e60763"}[chunkId] + ".chunk.js";
};